<template>
	<div class="map-tooltip-style legend-position-2">
		<Spin :spinning="isLoading">
			<VerticalLayout class="pd-vertical">
				<TypographyTitle :level="3">{{ $t('cnet-constructor.legend.otherGrids.title') }}</TypographyTitle>
				<TypographyParagraph type="secondary">{{ $t('cnet-constructor.legend.otherGrids.description') }}</TypographyParagraph>
				<Table
					size="small"
					:columns="columns"
					:data-source="otherGridsList"
					:pagination="false"
					rowKey="id"
					:row-selection="{ selectedRowKeys: selectedOtherGridsKeysRef, onChange: onSelect }"
					:scroll="{ y: 200 }"
				>
				</Table>
			</VerticalLayout>
		</Spin>
	</div>
</template>

<script>
import { useVModel } from '@vueuse/core';

import {
	TypographyTitle, TypographyParagraph,
	Table, Spin,
} from 'ant-design-vue';

import VerticalLayout from '@/components/common/VerticalLayout.vue';
import Consts from '@/api/Consts';


export default {
	components: {
		TypographyTitle, TypographyParagraph, Table, Spin,
		VerticalLayout,
	},
	props: {
		otherGridsList: {
			type: Array,
			required: true,
		},
		selectedOtherGridsKeys: {
			type: Array,
			required: true,
		},
		isLoading: {
			type: Boolean,
			required: true,
		},
	},
	setup(props, { emit }) {
		const selectedOtherGridsKeysRef = useVModel(props, 'selectedOtherGridsKeys', emit);
		const onSelect = keys => {
			selectedOtherGridsKeysRef.value = keys;
		};

		return {
			selectedOtherGridsKeysRef,
			columns: Consts.cnetOtherGridsTableColumnsComp,
			onSelect,
		};
	},
}
</script>

<style scoped>
@import '@/assets/map-legend.css';
</style>
